import { CompanyLinkType } from '@api*';
import { CompanyAnchor } from '@common';

type CompanyLinkTitleProps = {
  companyLink: CompanyLinkType;
  title: string;
};

export const CompanyLinkTitle: React.FC<CompanyLinkTitleProps> = ({
  companyLink,
  title,
}) => {
  if (companyLink.type === 'FREELANCER') return title;
  if (!companyLink.companyId) return title;

  const company = {
    type: 'COMPANY' as const,
    id: companyLink.companyId,
    name: title,
  };

  return <CompanyAnchor company={company} />;
};
